import { Container, Typography, Box, Grid, Paper } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DiscountIcon from '@mui/icons-material/Discount';
import SecurityIcon from '@mui/icons-material/Security';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import CardMembershipIcon from '@mui/icons-material/CardMembership';

const infoCards = [
  {
    icon: <CardGiftcardIcon sx={{ color: '#A2257C', fontSize: '2.2rem' }} />,
    text: 'Alla medlemskap är personliga och får inte delas med andra eller överlåtas till någon annan.',
  },
  {
    icon: <AccessTimeIcon sx={{ color: '#A2257C', fontSize: '2.2rem' }} />,
    text: 'Personlig träning ska avbokas senast 24 timmar innan, annars debiteras hela kostnaden.',
  },
  {
    icon: <CardMembershipIcon sx={{ color: '#A2257C', fontSize: '2.2rem' }} />,
    text: 'Frysning av medlemskort utan sjukintyg kostar 150 kr, och en avgift på 150 kr tillkommer vid återaktivering.',
  },
  {
    icon: <DiscountIcon sx={{ color: '#A2257C', fontSize: '2.2rem' }} />,
    text: 'Visdomsrabatt får de som inte fyllt 18 år än och de som fyllt 65 år.',
  },
  {
    icon: <SecurityIcon sx={{ color: '#A2257C', fontSize: '2.2rem' }} />,
    text: 'Vi har 15-års gräns i studion.',
  },
];

const MembershipInfo = () => (
  <Container sx={{ py: { xs: 5, md: 8 } }}>
    <Typography
      variant="h3"
      align="center"
      sx={{
        fontWeight: 'bold',
        color: '#007C85',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        mb: 3,
      }}
    >
      Våra Medlemskap
    </Typography>

    <Typography
      variant="body1"
      align="center"
      sx={{
        fontSize: '1.15rem',
        color: '#555',
        maxWidth: '700px',
        mx: 'auto',
        mb: 5,
      }}
    >
      Utforska våra medlemskap och hitta det som passar dig bäst. Anmäl dig genom att klicka på ett av alternativen nedan.
    </Typography>

    {/* Registration iframe */}
    <Box
      sx={{
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0 6px 24px rgba(0, 0, 0, 0.08)',
        backgroundColor: '#fff',
        maxHeight: '900px',
        mb: 6,
      }}
    >
      <iframe
        src="https://PILATESHOGANAS.wondr.se/register/"
        width="100%"
        height="1000"
        frameBorder="0"
        style={{ border: 'none', width: '100%', minHeight: '600px' }}
        title="Membership Registration"
      ></iframe>
    </Box>

    {/* Membership Info Cards (moved to bottom) */}
    <Grid container spacing={4} justifyContent="center">
      {infoCards.map((card, index) => (
        <Grid item xs={12} sm={6} md={5} key={index}>
          <Paper
            elevation={3}
            sx={{
              p: 3,
              borderRadius: '16px',
              display: 'flex',
              alignItems: 'flex-start',
              gap: 2,
              backgroundColor: '#fdfdfd',
              boxShadow: '0 6px 18px rgba(0,0,0,0.05)',
            }}
          >
            {card.icon}
            <Typography variant="body1" sx={{ color: '#555', fontSize: '1rem', lineHeight: 1.6 }}>
              {card.text}
            </Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  </Container>
);

export default MembershipInfo;
